import ProfilePasswordForm from './ProfilePasswordForm';
export default ProfilePasswordForm;
